import {
    GET_RAVEN_TRANSACTION_TYPE_DEF,
    GET_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS,
    ADD_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS,
    UPDATE_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS,
    DELETE_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS,
    RAVEN_TRANSACTION_TYPE_DEF_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
    recordList: [], //model data ve error
    error: {},
    loading: false,
}

const ravenTransactionTypeDef = (state = INIT_STATE, action) => {
    switch(action.type) {

        case GET_RAVEN_TRANSACTION_TYPE_DEF:
            return {
                ...state,
                loading: true,
            }

        case GET_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS:
            return {
                ...state,
                recordList: action.payload,
                loading: false
            }

        case ADD_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS:
            return {
                ...state,
                recordList: [...state.recordList, action.payload],
            }

        case UPDATE_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS:
           return {
                ...state,
                recordList: state.recordList.map(record =>
                    record.guid.toString() === action.payload.guid.toString()
                    ? { record, ...action.payload }
                    : record
                ),
            }
        
        case DELETE_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS:
            return {
                ...state,
                recordList: state.recordList.filter(
                    record => record.guid.toString() !== action.payload.toString()
                ),
            }

        case RAVEN_TRANSACTION_TYPE_DEF_API_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            }

        default:
            return state
    }
}

export default ravenTransactionTypeDef